import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Spin, Tooltip, Badge } from 'antd';
import ProgressBar from '../../../../shared-components/ProgressBar';
import { STATUS } from '../../../../redux/constants';
import styles from './threat-detail.module.sass';
import cx from 'classnames';
import Icon, { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as OpenNewWindowSVG } from '../../../../assets/threat-ranking/threat-detail/open_in_new_window.svg';
import { ReactComponent as TorExitNodeSVG } from '../../../../assets/threat-ranking/threat-detail/tor_exit_node.svg';
import { ReactComponent as DSLDynamicSVG } from '../../../../assets/threat-ranking/threat-detail/is_dsl_dynamic.svg';
import { ReactComponent as KnownBenign } from '../../../../assets/icons/KnownBenign.svg';
import { ReactComponent as SinkholeSVG } from '../../../../assets/threat-ranking/threat-detail/sinkhole.svg';
import { ReactComponent as AlexaTop10kSVG } from '../../../../assets/threat-ranking/threat-detail/alexa_top10k.svg';
import { ReactComponent as PartOfDGASVG } from '../../../../assets/threat-ranking/threat-detail/part_of_dga.svg';
import { ReactComponent as URLShortenerSVG } from '../../../../assets/threat-ranking/threat-detail/url_shortener.svg';
import { ReactComponent as ParkedSVG } from '../../../../assets/threat-ranking/threat-detail/parked.svg';
import { ReactComponent as ExpiredSVG } from '../../../../assets/threat-ranking/threat-detail/expired.svg';
import { ReactComponent as IPFS } from '../../../../assets/threat-ranking/threat-detail/ipfs.svg';
import { ReactComponent as OpenDirectorySVG } from '../../../../assets/open_dir.svg';
import { ReactComponent as HasExpiredCertificateSVG } from '../../../../assets/certificate_expire.svg';
import { ReactComponent as IsNewSVG } from '../../../../assets/threat-ranking/threat-detail/is_new.svg';
import { ReactComponent as TwitterLogoSVG } from '../../../../assets/threat-ranking/threat-detail/twitter_logo.svg';
import { ReactComponent as CopySVG } from '../../../../assets/icons/Copy.svg';
import { ReactComponent as SilentPushIOCLogoSVG } from '../../../../assets/threat-ranking/threat-detail/sp_ioc_logo.svg';
import { ReactComponent as DownloadSVG } from '../../../../assets/icons/Download.svg';
import { ReactComponent as TooltipSVG } from '../../../../assets/icons/help.svg';
import { ReactComponent as ClockSVG } from '../../../../assets/threat-ranking/threat-detail/clock.svg';
import TagList from '../../../IOCContainer/components/TagList';
//import { ReactComponent as ExploreSVG } from '../../../../assets/threat-ranking/threat-detail/explore.svg';
import { ReactComponent as ExploreSVG } from '../../../../assets/icons/Compass.svg';
import moment from 'moment-timezone';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import mixpanel from 'mixpanel-browser';
import { NotesList } from '../Notes/NotesList';
import { Link, useLocation } from 'react-router-dom';
import ScoreBadge from '../../../../shared-components/ScoreBadge';

const { confirm } = Modal;

function IOCDetail(props) {
  const {
    record,
    detailStatus,
    newDetailsStatus,
    setExpandedRowsKeys,
    scoreDetails: scoreData,
    newScoreDetails,
    mySubscriptionPlan,
  } = props;

  useEffect(() => {
    if (props.expanded) {
      props.loadScoreDetails(record?.uuid, record?.sourceUuid);
      props.loadNewScoreDetails(record?.sourceUuid);
    } else {
      props.clearScoreDetails();
    }

    //cleanup function
    return () => props.clearScoreDetails();
  }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = detailStatus === STATUS.LOADING;

  return (
    <>
      {isLoading && (
        <Spin indicator={<LoadingOutlined />} style={{ margin: 0 }} />
      )}
      {detailStatus === STATUS.LOADED &&
        newDetailsStatus == STATUS.LOADED &&
        scoreData?.total !== undefined && (
          <ScoreCard
            expanded={props.expanded}
            ioc={scoreData}
            newScoreDetails={newScoreDetails}
            exportSingleIOC={props.exportSingleIOC}
            history={props.history}
            setExpandedRowsKeys={setExpandedRowsKeys}
            toggleFalsePositive={props.toggleFalsePositive}
            toggleTruePositive={props.toggleTruePositive}
            toggleLeftMenu={props.toggleLeftMenu}
            resetEnrichment={props.resetEnrichment}
            mySubscriptionPlan={mySubscriptionPlan}
          />
        )}
      {detailStatus === STATUS.LOADED &&
        scoreData?.total === undefined &&
        scoreData?.status !== 'cleared' && (
          <div style={{ margin: 20 }}>
            <span style={{ fontSize: 20 }}>
              IOC has expired or doesn't exist anymore.
            </span>
          </div>
        )}
    </>
  );
}

export const ScoreCard = ({
  expanded,
  ioc,
  newScoreDetails,
  setExpandedRowsKeys,
  exportSingleIOC,
  history,
  toggleFalsePositive,
  toggleTruePositive,
  toggleLeftMenu,
  openedAsPopup,
  mySubscriptionPlan,
  ...props
}) => {
  return (
    <>
      <ScoreCardHeader
        expanded={expanded}
        ioc={ioc}
        openedAsPopup={openedAsPopup}
        setExpandedRowsKeys={setExpandedRowsKeys}
        exportSingleIOC={exportSingleIOC}
        history={history}
        toggleFalsePositive={toggleFalsePositive}
        toggleTruePositive={toggleTruePositive}
        toggleLeftMenu={toggleLeftMenu}
        resetEnrichment={props.resetEnrichment}
        mySubscriptionPlan={mySubscriptionPlan}
      />
      <FeedSection ioc={ioc} newScoreDetails={newScoreDetails} />
      <EnrichedSection history={history} ioc={ioc} />
      <CustomAttributesSection ioc={ioc} />
    </>
  );
};

const SectionTitle = ({ sectionTitle, ...props }) => {
  return (
    <div style={{ display: 'inline-block', marginLeft: '8px' }}>
      <span className={styles['section-title']}>{sectionTitle}</span>
    </div>
  );
};

const FeedSection = ({ ioc, newScoreDetails, ...props }) => {
  const SilentPushIOCLogo = (props) => (
    <Icon
      style={{ fontSize: '24px' }}
      component={SilentPushIOCLogoSVG}
      {...props}
    />
  );
  return (
    <div style={{ background: '#16262B' }}>
      <Row>
        <Col
          style={{
            flex: '1 1 calc(100% - 135px)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          }}
        >
          <div
            style={{
              paddingLeft: '16px',
              paddingTop: '16px',
              textAlign: 'left',
            }}
          >
            <SilentPushIOCLogo />
            <SectionTitle sectionTitle={'Silent Push Source Attributes'} />
          </div>
          <Row style={{ textAlign: 'left', padding: '16px 0 16px 16px' }}>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicator name={'Source Name'} value={ioc?.source_name} />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicator name={'Vendor'} value={ioc?.source_vendor_name} />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicator
                name={'Last Updated'}
                value={
                  ioc?.last_seen_on
                    ? moment(ioc?.last_seen_on).format('YYYY-MM-DD HH:mm')
                    : ''
                }
                tooltipText={'Timestamp when feed was last collected'}
              />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicatorWithScore
                tooltipText={
                  'The interval between updates when the next update will happen'
                }
                name={'Frequency'}
                score={ioc?.source_frequency_score}
                value={ioc?.source_frequency}
                auxilaryText={'hours'}
              />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicatorWithScore
                tooltipText={
                  'Feed accuracy is based on user feedback regarding the false positives from the threat intelligence feed'
                }
                name={'Accuracy'}
                score={ioc?.source_accuracy_score ?? 0}
                value={ioc?.source_accuracy_score ?? 0}
                auxilaryText={'score'}
              />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicatorWithScore
                tooltipText={
                  'Number of false positives for the feed in last 30 days'
                }
                name={'False Positive'}
                score={ioc?.source_false_positive_ratio ?? 0}
                value={ioc?.source_false_positive_count ?? 0}
                auxilaryText={'false positives'}
              />
            </Col>
            {ioc?.source_geographic_spread_continents?.length > 0 ? (
              <Col xxl={3} xl={4} md={4}>
                <ValueIndicatorWithScore
                  tooltipText={
                    'The number of continents covered within the threat Intelligence feed based on IP origin information.'
                  }
                  name={'GEO Spread'}
                  score={ioc?.source_geographic_spread_score ?? 0}
                  value={
                    ioc?.source_geographic_spread_continents?.length ?? 'n/a'
                  }
                  auxilaryText={'continents'}
                />
              </Col>
            ) : (
              ''
            )}
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicatorWithScore
                tooltipText={
                  "The percentage of the feed's observables that are provided by other feeds/collections"
                }
                name={'Overlap'}
                score={newScoreDetails?.overlap_score}
                isInfo={true}
                value={newScoreDetails?.overlap_score}
                auxilaryText={'%'}
              />
            </Col>
            <Col xxl={3} xl={4} md={4}>
              <ValueIndicatorWithScore
                tooltipText={
                  'The percentage of firstly reported observables since the feed/collection was added'
                }
                name={'Originator'}
                score={newScoreDetails?.originator_score}
                isInfo={true}
                value={newScoreDetails?.originator_score}
                auxilaryText={'%'}
              />
            </Col>
          </Row>
        </Col>
        <Col flex="135px" className={styles.badge_container}>
          <ScoreBadge
            score={ioc?.total_source_score}
            scoreTextDescription="Source Score"
            scoreTextRecolor={true}
            scoreProgressRecolor={true}
            boxOpacity={'.08'}
            boxBordered={true}
          />
        </Col>
      </Row>
    </div>
  );
};

const EnrichedSection = ({ ioc, history, ...props }) => {
  function convertDateTimeString(text, format) {
    let datetime = 'n/a';

    if (!!text && text !== 'UNKNOWN') {
      datetime = moment.utc(text, format).format('YYYY-MM-DD').toString();
    }
    return datetime;
  }
  const ExploreIcon = (props) => (
    <Icon
      component={() => (
        <ExploreSVG fill={'#3C9AE8'} style={{ width: 12, height: 12 }} />
      )}
    />
  );

  const IPDiversityIcon = (props) => (
    <Icon
      component={() => (
        <ClockSVG style={{ width: 16, height: 16 }} fill={'#65B7F3'} />
      )}
      {...props}
    />
  );
  const domainAttributes = [
    {
      name: 'Age',
      score: ioc?.age_score,
      value: ioc?.age ?? 'n/a',
      auxilaryText: 'days',
      isScoredIndicator: true,
      tooltipText:
        'The number of days since the domain was first seen in the zone files',
    },
    {
      name: 'NS Reputation',
      score: ioc?.ns_reputation_score,
      value: ioc?.ns_reputation_score,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'Ratio of blacklisted domains from the total number of domains using this name server',
    },
    {
      name: 'NS Entropy',
      score: ioc?.ns_entropy_score,
      value: ioc?.ns_entropy_score,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'Formulated score incorporating recency, frequency, and number of NS changes. Any entropy is noteworthy.',
    },
    {
      name: 'NS Average TTL',
      score: ioc?.nsdomaininfo?.[0]?.ns_avg_ttl_score,
      value: ioc?.nsdomaininfo?.[0]?.ns_avg_ttl,
      auxilaryText: 'seconds',
      isScoredIndicator: true,
    },
    {
      name: 'Generated Domain Probability',
      score: ioc?.dga_probability_score,
      value: ioc?.dga_probability_score,
      auxilaryText: 'score',
      isScoredIndicator: true,
      //isPercentage: true,
      tooltipText:
        'Likelihood that the domain was created by a domain generation algorithm',
    },
    {
      name: 'Curated Feeds History Score',
      score: ioc?.listing_score ?? 0,
      value: ioc?.listing_score ?? 0,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'The Curated Feeds History score is a score based on the frequency and recency of this observable in feeds that we trust.',
    },
    {
      name: 'IP Diversity',
      value: ioc?.ip_diversity_all,
      tooltipText: 'Number of IPs pointed to over the last 30 days',
      isScoredIndicator: false,
      actionComponent: () => (
        <Tooltip title={'Show Timeline'}>
          <Link
            to={`explore-result?name=${
              ioc?.name.startsWith('http://') ||
              ioc?.name.startsWith('https://') ||
              ioc?.name.includes('/')
                ? new URL(ioc?.name)?.host
                : ioc?.name
            }&queryType=ipdiversity&type=A&row=${ioc?.uuid}`}
          >
            <Button
              icon={<IPDiversityIcon />}
              style={{ border: 0, marginLeft: 3 }}
              type={'primary'}
              size={'small'}
            >
              Show Timeline
            </Button>
          </Link>
        </Tooltip>
      ),
    },
  ];
  const ipAttributes = [
    {
      name: 'IP Reputation',
      score: ioc?.ip_reputation_score,
      value: ioc?.ip_reputation_score,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'Score calculated on the number of domain names currently listed on a feed that are hosted on this IP',
    },
    {
      name: 'ASN Takedown Reputation',
      score: ioc?.asn_takedown_reputation_score,
      value: ioc?.asn_takedown_reputation,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'Reputation score calculated based on the observed time it takes for the ASN owner to react to takedown requests related to malicious URLs - a higher reputation score indicates the ASN owner is slow to react to takedown requests',
    },
    {
      name: 'ASN Rank',
      score: ioc?.asn_rank_score,
      value: ioc?.asn_rank,
      isScoredIndicator: true,
      tooltipText:
        'A ranking of ASNs seen to host threats listed on feeds, calculated using a weighted formula based on the type of threat',
    },
    {
      name: 'ASN Allocation Date',
      value: ioc?.asn_allocation_date
        ? convertDateTimeString(ioc?.asn_allocation_date.toString())
        : 'n/a',
      isScoredIndicator: false,
      tooltipText: 'Date AS number was assigned by IANA',
    },
    {
      name: 'ASN Allocation Age',
      value:
        ioc?.asn_allocation_age !== 'UNKNOWN' ? ioc?.asn_allocation_age : 'n/a',
      isScoredIndicator: false,
      auxilaryText: 'days',
      tooltipText: 'Age of AS number (in days)',
    },
    {
      name: 'AS Name',
      value: ioc?.asname,
      isScoredIndicator: false,
    },
    {
      name: 'ASN Reputation',
      score: ioc?.asn_reputation_score,
      value: ioc?.asn_reputation,
      isScoredIndicator: true,
      tooltipText:
        'Ratio of blacklisted IPs from the total number of IPs that have been observed as being active within this ASN in the last 30 days',
    },
    {
      name: 'Subnet Reputation',
      score: ioc?.subnet_reputation_score,
      value: ioc?.subnet_reputation,
      isScoredIndicator: true,
      tooltipText:
        'Ratio of blacklisted IPs from the total number of IPs that have been observed as being active within this subnet in the last 30 days',
    },
    {
      name: 'Subnet',
      value: ioc?.subnet,
      isScoredIndicator: false,
      tooltipText: 'The subnet containing the IP',
    },
    {
      name: 'AS Number',
      value: ioc?.asn,
      isScoredIndicator: false,
      tooltipText: 'Number for the AS, allocated by IANA',
    },
    {
      name: 'IP Density',
      value: ioc?.density?.toString() ?? 0,
      isScoredIndicator: false,
      tooltipText: 'Number of domains with A records pointing to IP address',
      actionComponent: () => (
        <Tooltip title={'Lookup domains'}>
          <Link
            to={`/explore-result?name=${ioc?.ipv4}&queryType=answer&type=A&row=${ioc?.uuid}`}
          >
            <Button
              onClick={() => {
                mixpanel.track('Explore', {
                  location: 'enrich',
                  ioc_type: 'IP',
                  explored_type: 'reverseA',
                });
              }}
              style={{ border: 0, marginLeft: 3 }}
              type={'primary'}
              size={'small'}
              icon={<ExploreIcon aria-label={'lookDom'} />}
            >
              Lookup Domains
            </Button>
          </Link>
        </Tooltip>
      ),
    },
    {
      name: 'IP PTR',
      value:
        ioc?.ip_ptr?.length > 20 ? (
          <Tooltip title={ioc?.ip_ptr}>
            {' '}
            {ioc?.ip_ptr?.substring(0, 20) + '...'}{' '}
          </Tooltip>
        ) : (
          ioc?.ip_ptr
        ),
      isScoredIndicator: false,
      tooltipText: 'PTR record pointing to this IP (if exists)',
    },
    {
      name: 'Curated Feeds History Score',
      score: ioc?.listing_score ?? 0,
      value: ioc?.listing_score ?? 0,
      auxilaryText: 'score',
      isScoredIndicator: true,
      tooltipText:
        'The Curated Feeds History score is a score based on the frequency and recency of this observable in feeds that we trust.',
    },
  ];
  const SilentPushIOCLogo = (props) => (
    <Icon
      style={{ fontSize: '24px' }}
      component={SilentPushIOCLogoSVG}
      {...props}
    />
  );

  const renderIndicator = (indicator, idx) => {
    if (indicator['isScoredIndicator']) {
      return (
        <Col key={idx} className={styles['margin-col']} xxl={3} xl={4} md={4}>
          <ValueIndicatorWithScore
            name={indicator['name']}
            isPercentage={indicator['isPercentage']}
            value={indicator['value']}
            score={indicator['score']}
            auxilaryText={indicator['auxilaryText']}
            key={idx}
            tooltipText={indicator['tooltipText']}
          />
        </Col>
      );
    }
    return (
      <Col key={idx} className={styles['margin-col']} xxl={3} xl={4} md={4}>
        <ValueIndicator
          name={indicator['name']}
          value={indicator['value']}
          key={idx}
          auxilaryText={indicator['auxilaryText']}
          tooltipText={indicator['tooltipText']}
          actionComponent={indicator['actionComponent']}
        />
      </Col>
    );
  };

  return (
    <div style={{ background: '#16262B' }}>
      <Row>
        <Col
          style={{
            flex: '1 1 calc(100% - 135px)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          }}
        >
          <div
            style={{
              paddingLeft: '16px',
              paddingTop: '16px',
              textAlign: 'left',
            }}
          >
            <SilentPushIOCLogo />
            <SectionTitle sectionTitle={'Silent Push Enriched Attributes'} />
          </div>
          <Row
            gutter={[16, 16]}
            style={{ padding: '16px 0 16px 16px', textAlign: 'left' }}
          >
            {ioc?.ioc_template?.toLowerCase() === 'domain' &&
              domainAttributes.map((d, idx) => renderIndicator(d, idx))}
            {ioc?.ioc_template?.toLowerCase() === 'ip' &&
              ipAttributes.map((i, idx) => renderIndicator(i, idx))}
          </Row>
          <BadgesSection ioc={ioc} />
        </Col>
        <Col flex="135px" className={cx(styles.badge_container)}>
          <ScoreBadge
            score={ioc?.total_ioc}
            scoreTextDescription="Enriched Score"
            scoreTextRecolor={true}
            scoreProgressRecolor={true}
            boxOpacity={'.08'}
            boxBordered={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export const BadgeSection = ({ style, title, renderIcon, ...props }) => {
  return (
    <div
      style={{
        marginRight: '10px',
        display: 'flex',
        alignItems: 'center',
        ...(style ?? {}),
      }}
    >
      {renderIcon()}
      <span
        style={{
          display: 'inline-block',
          marginLeft: 8,
          fontSize: 14,
          fontWeight: 600,
          color: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        {title}
      </span>
    </div>
  );
};

export const BadgesSection = ({ ioc, style, ...props }) => {
  const badges = [
    {
      title: 'Tor exit node',
      condition: ioc?.ip_is_tor_exit_node,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <TorExitNodeSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'DSL Dynamic',
      condition: ioc?.ip_is_dsl_dynamic,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <DSLDynamicSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Dynamic Domain',
      condition: ioc?.is_dynamic_domain,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <DSLDynamicSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Sinkhole',
      condition: ioc?.known_sinkhole_ip,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <SinkholeSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Sinkhole',
      condition: ioc?.is_sinkholed,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <SinkholeSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Alexa Top 10k',
      condition: ioc?.is_alexa_top10k,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <AlexaTop10kSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Part of DGA',
      condition: ioc?.dga_probability_score === 100,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <PartOfDGASVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'URL Shortener',
      condition: ioc?.is_url_shortener,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <URLShortenerSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'New',
      condition: ioc?.is_new_score === 100,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <IsNewSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Known Benign',
      condition: ioc?.known_benign,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => (
            <KnownBenign style={{ width: 32, height: 32 }} fill={'none'} />
          )}
          {...props}
        />
      ),
    },
    {
      title: 'Parked',
      condition: ioc?.is_parked,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <ParkedSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Expired',
      condition: ioc?.is_expired,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <ExpiredSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Open Directory',
      condition: ioc?.ip_has_open_directory,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <OpenDirectorySVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: 'Expired Certificate',
      condition: ioc?.ip_has_expired_certificate,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <HasExpiredCertificateSVG fill={'none'} />}
          {...props}
        />
      ),
    },
    {
      title: '',
      condition: ioc?.ip_is_ipfs_node,
      renderIcon: () => (
        <Icon
          style={{ fontSize: 32 }}
          component={() => <IPFS fill={'none'} />}
          {...props}
        />
      ),
    },
  ];
  const [badgesToDisplay, setBadgesToDisplay] = useState([]);
  useEffect(() => {
    setBadgesToDisplay(badges.filter((b) => b.condition));
  }, [ioc]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div
      style={{
        textAlign: 'left',
        padding: '0 9px 9px 16px',
        display: badgesToDisplay.length ? 'block' : 'none',
        ...(style ?? {}),
      }}
    >
      <div
        style={{
          paddingTop: '9px',
          display: 'flex',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        {badgesToDisplay.map((b, idx) => (
          <BadgeSection
            key={idx}
            title={b['title']}
            renderIcon={b['renderIcon']}
          />
        ))}
      </div>
    </div>
  );
};

const CustomAttributesSection = ({ ioc, ...props }) => {
  const domainAttributes = [
    {
      name: 'Customer Domain Score',
      value: ioc?.company_domains_score,
      score: ioc?.company_domains_score,
      auxilaryText: 'score',
      tooltipText:
        "Formulated score expressing the observable's similarity to your organization's designated customer domains (set in the indicators section of preferences)",
    },
    {
      name: 'Top Brands Score',
      value: ioc?.brand_domains_score,
      score: ioc?.brand_domains_score,
      auxilaryText: 'score',
      tooltipText:
        "Formulated score expressing the observable's similarity to your organization's designated brand domains (set in the indicators section of preferences)",
    },
    {
      name: 'Supplier Domain Score',
      value: ioc?.supply_domains_score,
      score: ioc?.supply_domains_score,
      auxilaryText: 'score',
      tooltipText:
        "Formulated score expressing the observable's similarity to your organization's designated supplier domains (set in the indicators section of preferences)",
    },
  ];
  const ipAttributes = [
    {
      name: 'IP GEO',
      value: ioc?.geo_ip_score,
      score: ioc?.geo_ip_score,
      auxilaryText: 'score',
      tooltipText:
        "Calculated score expressing the IP's presence in your organization's designated countries (set in the indicators section of preferences)",
    },
    {
      name: 'IP Range',
      value: ioc?.ipv4_ranges_score,
      score: ioc?.ipv4_ranges_score,
      auxilaryText: 'score',
      tooltipText:
        'If the IP address matches any of the IP Ranges defined in the Preferences -> Indicators settings',
    },
  ];
  const SilentPushIOCLogo = (props) => (
    <Icon
      style={{ fontSize: '24px' }}
      component={SilentPushIOCLogoSVG}
      {...props}
    />
  );
  return (
    <div style={{ background: '#16262B' }}>
      <Row>
        <Col flex="auto">
          <div
            style={{
              paddingLeft: '16px',
              paddingTop: '16px',
              textAlign: 'left',
            }}
          >
            <SilentPushIOCLogo />
            <SectionTitle sectionTitle={'Silent Push Custom Attributes'} />
          </div>
          {/*<div style={{display: "flex", padding: "16px 0 16px 16px", textAlign: "left"}}> */}
          <Row style={{ padding: '16px 0 16px 16px', textAlign: 'left' }}>
            {ioc?.ioc_template?.toLowerCase() === 'domain' &&
              domainAttributes.map((d, idx) => (
                <Col key={idx} xxl={3} md={4} xl={4}>
                  <ValueIndicatorWithScore
                    name={d['name']}
                    isPercentage={d['isPercentage']}
                    value={d['value']}
                    score={d['score']}
                    auxilaryText={d['auxilaryText']}
                    key={idx}
                    tooltipText={d['tooltipText']}
                  />
                </Col>
              ))}
            {ioc?.ioc_template?.toLowerCase() === 'ip' &&
              ipAttributes.map((i, idx) => (
                <Col key={idx} xxl={3} md={4} xl={4}>
                  <ValueIndicatorWithScore
                    name={i['name']}
                    isPercentage={i['isPercentage']}
                    value={i['value']}
                    score={i['score']}
                    auxilaryText={i['auxilaryText']}
                    key={idx}
                    tooltipText={i['tooltipText']}
                  />
                </Col>
              ))}
          </Row>
        </Col>
        <Col flex="135px" className={styles.badge_container}>
          <ScoreBadge
            score={ioc.total_custom}
            scoreTextDescription="Custom Score"
            scoreTextRecolor={true}
            scoreProgressRecolor={true}
            boxOpacity={'.08'}
            boxBordered={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export const ValueIndicatorWithScore = ({
  name,
  value,
  score,
  tooltipText,
  auxilaryText,
  isPercentage,
  isInfo,
  style,
  titleComponent,
  renderAdditionalActionComponent,
  ...props
}) => {
  const TooltipIcon = (props) => (
    <Icon component={TooltipSVG} fill={'white'} {...props} />
  );
  let scoreColor = '#1f9110';
  if (score > 40) {
    scoreColor = '#E84749';
  } else if (score >= 25) {
    scoreColor = '#f3be00';
  }
  if (isInfo) {
    scoreColor = '#3C9AE8';
  }

  const renderIndicatorTitle = () => {
    if (titleComponent) {
      return <div style={{ marginBottom: 8 }}>{titleComponent()}</div>;
    }
    const ActionComponent =
      renderAdditionalActionComponent && renderAdditionalActionComponent();
    if (tooltipText) {
      return (
        <div>
          <Tooltip title={tooltipText}>
            <span
              style={{ marginRight: 4 }}
              className={styles['value-indicator-title']}
            >
              {name}
            </span>
            <TooltipIcon />
          </Tooltip>
          {renderAdditionalActionComponent && <ActionComponent />}
        </div>
      );
    }
    return (
      <div>
        <span className={styles['value-indicator-title']}>{name}</span>
      </div>
    );
  };

  return (
    <div style={style} className={styles['value-indicator']}>
      {renderIndicatorTitle()}
      <div>
        <span className={styles['value-indicator-value']}>
          {value ?? 'n/a'} {value && isPercentage ? '%' : ''}
        </span>
        {value >= 0 && (
          <span className={styles['value-indicator-auxilary']}>
            {auxilaryText}
          </span>
        )}
      </div>
      <div style={{ marginTop: 2 }}>
        <ProgressBar bgcolor={scoreColor} width={'72'} completed={score} />
      </div>
    </div>
  );
};

export const ValueIndicator = ({
  name,
  value,
  tooltipText,
  style,
  auxilaryText,
  actionComponent,
  ...props
}) => {
  const TooltipIcon = (props) => (
    <Icon component={TooltipSVG} fill={'white'} {...props} />
  );
  const renderIndicatorTitle = () => {
    if (tooltipText) {
      return (
        <Tooltip title={tooltipText}>
          <div>
            <span
              style={{ marginRight: 4 }}
              className={styles['value-indicator-title']}
            >
              {name}
            </span>
            <TooltipIcon />
          </div>
        </Tooltip>
      );
    }
    return (
      <div>
        <span className={styles['value-indicator-title']}>{name}</span>
      </div>
    );
  };
  return (
    <div style={style} className={styles['value-indicator']}>
      {renderIndicatorTitle()}
      <span className={styles['value-indicator-value']}>
        {value ? value : 'n/a'}
      </span>
      {value >= 0 && (
        <span className={styles['value-indicator-auxilary']}>
          {auxilaryText}
        </span>
      )}
      {actionComponent && actionComponent()}
    </div>
  );
};

const ScoreCardHeader = ({
  expanded,
  ioc,
  setExpandedRowsKeys,
  exportSingleIOC,
  history,
  toggleFalsePositive,
  toggleTruePositive,
  toggleLeftMenu,
  openedAsPopup,
  ...props
}) => {
  const CopyIcon = (props) => (
    <Icon component={() => <CopySVG fill={'white'} />} {...props} />
  );
  const DownloadIcon = (props) => (
    <Icon component={() => <DownloadSVG fill={'white'} />} {...props} />
  );
  const OpenNewWindowIcon = (props) => (
    <Icon
      component={() => (
        <OpenNewWindowSVG style={{ width: 16, height: 16 }} fill={'white'} />
      )}
      {...props}
    />
  );
  const TwitterIcon = (props) => (
    <Icon
      component={() => (
        <TwitterLogoSVG style={{ width: 16, height: 16 }} fill={'white'} />
      )}
      {...props}
    />
  );

  function toggleWindowPortal() {
    let newWindow = window.open(
      window.location.origin +
        '/ioc?id=' +
        ioc?.uuid +
        '&feed=' +
        ioc?.source_uuid,
      '',
      'width=1400,height=850,left=200,top=200',
    );
    // @TODO: needs more work to hide the left menu when IOC detail opened in new window
    // newWindow.onload = toggleLeftMenu(false);
    mixpanel.track('Open in New Window', {
      location: 'threat detail',
      ioc_type: ioc?.type,
      feed: ioc?.feed,
      vendor: ioc?.feeds?.vendor,
    });
  }

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function shareOnTwitter(ioc) {
    const text = encodeURIComponent(
      `Possible threat alert: ${ioc?.name} found on `.replaceAll('.', '[.]'),
    );
    const url = encodeURIComponent('https://www.silentpush.com');
    const via = 'silentpush';
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${url}&via=${via}`,
      '_blank',
    );
  }

  function extractHostFromIOC(iocName) {
    let iocToQuery = iocName;
    if (ioc?.type === 'url') {
      try {
        const iocURL = new URL(iocName);
        iocToQuery = iocURL.hostname;
      } catch (e) {
        console.error(
          "IOC type reported as URL whereas the actual type isn't.",
        );
        console.error(e);
        throw e;
      }
    }
    return iocToQuery;
  }

  const q = new URLSearchParams(useLocation().search);
  function compileEnrichURL(iocName, type) {
    let iocToEnrich = iocName;
    if (type === 'url') {
      iocToEnrich = encodeURIComponent(iocName);
    }
    return (
      `/enrichment?row=${ioc?.uuid}&name=${iocToEnrich}&type=${ioc?.ioc_template}&backLink=` +
      encodeURIComponent(window.location.pathname) +
      encodeURIComponent(`?row=${ioc?.uuid}`) +
      encodeURIComponent(q.get('feed') ? `&feed=${q.get('feed')}` : '') +
      encodeURIComponent(q.get('vendor') ? `&vendor=${q.get('vendor')}` : '') +
      encodeURIComponent(
        q.get('feed_state') ? `&feed_state=${q.get('feed_state')}` : '',
      )
    );
  }

  function navigateToEnrich(iocName, type) {
    let iocToEnrich = iocName;
    if (type === 'url') {
      iocToEnrich = encodeURIComponent(iocName);
    }
    history.push(
      `/enrichment?row=${ioc?.uuid}&name=${iocToEnrich}&type=${type}&backLink=` +
        encodeURIComponent(window.location.pathname) +
        encodeURIComponent(`?row=${ioc?.uuid}`),
    );
  }

  function compileExploreURL(iocName, type, queryType = 'query') {
    let iocToQuery = extractHostFromIOC(iocName);
    let typeOfQuery = type;
    if (ioc?.type === 'url') {
      if (ioc?.ioc_template === 'ip') {
        typeOfQuery = 'ANYIPV4';
      }
    }
    return (
      `/explore-result?name=${iocToQuery}&queryType=${queryType}&type=${typeOfQuery}&row=${ioc?.uuid}&backLink=` +
      encodeURIComponent(window.location.pathname) +
      encodeURIComponent(`?row=${ioc?.uuid}`) +
      '&origin_uid=Explore&is_visualizable=1'
    );
  }

  function navigateToExplore(iocName, type, queryType = 'query') {
    let iocToQuery = extractHostFromIOC(iocName);
    let typeOfQuery = type;
    if (ioc?.type === 'url') {
      if (ioc?.ioc_template === 'ip') {
        typeOfQuery = 'ANYIPV4';
      }
    }
    history.push(
      `/explore-result?name=${iocToQuery}&queryType=${queryType}&type=${typeOfQuery}&row=${ioc?.feeds?.name}-${ioc?.uuid}&backLink=` +
        encodeURIComponent(window.location.pathname) +
        encodeURIComponent(`?row=${ioc?.uuid}`),
    );
  }

  function handleFalsePositive() {
    const title = ioc?.false_positive
      ? 'Are you sure you want to unmark this observable as False Positive?'
      : 'Are you sure you want to mark this observable as False Positive?';
    confirm({
      title,
      okText: 'Yes',
      onOk() {
        toggleFalsePositive({
          ...ioc,
          false_positive: !ioc?.false_positive,
        });
      },
      onCancel() {},
    });
  }

  function handleTruePositive() {
    const title = ioc?.true_positive
      ? 'Are you sure you want to unmark this observable as True Positive?'
      : 'Are you sure you want to mark this observable as True Positive?';
    confirm({
      title,
      okText: 'Yes',
      okButtonProps: {
        role: 'button5',
        label: 'okBtn',
      },
      onOk() {
        toggleTruePositive({
          ...ioc,
          true_positive: !ioc?.true_positive,
        });
      },
      onCancel() {},
    });
  }

  return (
    <div style={{ background: '#213A42' }}>
      <Row className={styles['score-card-header']}>
        <Col flex="1 1 calc(100% - 135px)">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              textAlign: 'left',
              paddingTop: '16px',
              paddingLeft: '16px',
            }}
          >
            {!openedAsPopup && (
              <Tooltip title={'Close Details'}>
                <DownOutlined
                  role={'button2'}
                  onClick={() => setExpandedRowsKeys([])}
                />
              </Tooltip>
            )}
            <Tooltip title={ioc?.name}>
              <span
                style={{
                  color: 'rgba(255, 255, 255, 0.85)',
                  display: 'inline-block',
                  marginLeft: '24px',
                  fontSize: '36px',
                  fontWeight: 700,
                }}
              >
                {ioc?.name?.length >= 60
                  ? ioc?.name?.substring(0, 55) +
                    '...' +
                    ioc?.name.substring(ioc?.name?.length - 3)
                  : ioc?.name}
              </span>
            </Tooltip>
            <Tooltip title={"Copy observable's name"}>
              <Button
                onClick={() => {
                  copyToClipboard(ioc?.name);
                  mixpanel.track('Copy Observable', {
                    location: 'threat detail',
                    ioc_type: ioc?.type,
                    feed: ioc?.feed,
                    vendor: ioc?.feeds?.vendor,
                  });
                }}
                style={{ marginLeft: '15px', border: 0 }}
                icon={<CopyIcon aria-label="copyObser" />}
                ghost
              />
            </Tooltip>
          </div>

          {/* </div> */}
          <div className={styles['tag-area']}>
            <div className={styles['type-chip']}>
              {ioc?.type?.toUpperCase()}
            </div>
            <div className={styles['ioc-type-tag-divider']}></div>
            <Tooltip title={'Export the observable as a CSV file'}>
              <Button
                onClick={() => {
                  exportSingleIOC(ioc?.uuid);
                  mixpanel.track('Export Observable', {
                    location: 'threat detail',
                    ioc_type: ioc?.type,
                    feed: ioc?.feed,
                    vendor: ioc?.feeds?.vendor,
                  });
                }}
                style={{ border: 0 }}
                icon={<DownloadIcon aria-label={'downIc'} />}
                ghost
              />
            </Tooltip>
            <Tooltip title="Share the observable on Twitter">
              <Button
                onClick={() => {
                  shareOnTwitter(ioc);
                  mixpanel.track('Tweet Observable', {
                    location: 'threat detail',
                    ioc_type: ioc?.type,
                    source: ioc?.source_name,
                    vendor: ioc?.source_vendor_name,
                  });
                }}
                style={{ border: 0 }}
                icon={<TwitterIcon aria-label={'twiIc'} />}
                ghost
              />
            </Tooltip>
            <Tooltip title={'Open in new window'}>
              <Button
                onClick={toggleWindowPortal}
                style={{ border: 0 }}
                icon={<OpenNewWindowIcon aria-label={'newWin'} />}
                ghost
              />
            </Tooltip>
            <div
              style={{
                marginLeft: '7px',
                marginRight: '7px',
                height: '32px',
                width: '1px',
                borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
              }}
            ></div>
            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_enrich ? (
                  'Look-up real-time data like whois information and name server history'
                ) : (
                  <>
                    Enrichment is not part of this subscription plan. To upgrade
                    your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              <Link to={() => compileEnrichURL(ioc?.name, ioc?.type)}>
                <Button
                  type="primary"
                  role="button"
                  disabled={!props.mySubscriptionPlan?.has_access_to_enrich}
                  onClick={() => {
                    props.resetEnrichment();
                    mixpanel.track('Enrich', {
                      location: 'threat detail',
                      'ioc type': [ioc?.type],
                      'source name': [ioc?.source_name],
                      vendor: [ioc?.source_vendor_name],
                    });
                  }}
                >
                  Enrich
                </Button>
              </Link>
            </Tooltip>
            <Tooltip
              title={
                props.mySubscriptionPlan?.has_access_to_explore ? (
                  'Browse DNS history and pivot into related infrastructure'
                ) : (
                  <>
                    This option is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                )
              }
            >
              <Link
                to={compileExploreURL(
                  ioc?.name,
                  ioc?.type?.toLowerCase() === 'ip' ? 'ANYIPV4' : 'any',
                )}
              >
                <Button
                  type="primary"
                  disabled={!props.mySubscriptionPlan?.has_access_to_explore}
                  onClick={() => {
                    mixpanel.track('Explore', {
                      location: 'threat detail',
                      'ioc type': [ioc?.type],
                      'source name': [ioc?.source_name],
                      vendor: [ioc?.source_vendor_name],
                    });
                  }}
                  style={{ marginLeft: '7px' }}
                >
                  Lookup PADNS
                </Button>
              </Link>
            </Tooltip>

            <div
              style={{
                marginLeft: '7px',
                marginRight: '7px',
                height: '32px',
                width: '1px',
                borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
              }}
            ></div>
            <Tooltip
              title={
                ioc?.false_positive
                  ? 'Unmark the observable as a false positive threat'
                  : 'Mark the observable as a false positive threat'
              }
            >
              <Button
                style={{
                  marginRight: 5,
                }}
                onClick={handleFalsePositive}
                className={
                  ioc?.false_positive
                    ? styles['false-positive-confirmed']
                    : styles['false-positive']
                }
                ghost
              >
                False positive
                {!!ioc?.false_positive_count && (
                  <Tooltip
                    placement="bottom"
                    title="Number of users that marked it as false positive"
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-10px',
                      }}
                    >
                      <Badge count={ioc.false_positive_count} />
                    </div>
                  </Tooltip>
                )}
              </Button>
            </Tooltip>
            <Tooltip
              title={
                ioc?.true_positive
                  ? 'Unmark the observable as a true positive threat'
                  : 'Mark the observable as a true positive threat: acknowledge it has been seen before'
              }
            >
              <Button
                onClick={handleTruePositive}
                className={
                  ioc?.true_positive
                    ? styles['true-positive-confirmed']
                    : styles['true-positive']
                }
                ghost
              >
                Seen it
                {!!ioc?.true_positive_count && (
                  <Tooltip
                    placement="bottom"
                    title="Number of users that marked it as true positive"
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-10px',
                      }}
                    >
                      <Badge count={ioc.true_positive_count} />
                    </div>
                  </Tooltip>
                )}
              </Button>
            </Tooltip>
          </div>
          <div
            style={{
              display: 'flex',
              paddingLeft: 10,
            }}
          >
            <TagList />
            <div
              style={{
                marginLeft: '12px',
                marginRight: '12px',
                alignSelf: 'center',
                height: '32px',
                width: '1px',
                display: 'flex',
                borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
              }}
            ></div>
            <NotesList
              iocUUID={ioc?.uuid}
              feedUUID={ioc?.source_uuid}
              expanded={expanded}
            />
          </div>
        </Col>
        <Col flex="135px" className={styles.badge_container}>
          <ScoreBadge
            score={ioc?.total}
            scoreTextDescription="Total Score"
            scoreTextRecolor={false}
            scoreProgressRecolor={false}
            boxBordered={false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default IOCDetail;
export const ScoreCardHeaderRouter = ScoreCardHeader;
export const IOCDetailExport = IOCDetail;
export const EnrichedSectionRouter = EnrichedSection;
export const ScoreBadgeExport = ScoreBadge;
